export default __webpack_public_path__ + "static/fonts/InclusiveSans-Medium_dhX8Sl.ttf";